/**
 *
 * @param {import("@/types/services/LibraryServiceTypes.mjs").SiteConfig} siteInfo
 */

export const prepareCreationData = (siteInfo, folderId) => {
  const { design_id, name, lib_design_id, pub_id } = siteInfo;

  const creationInfo = {
    name: `My ${name}`,
  };

  if (lib_design_id) {
    creationInfo.lib_design_id = lib_design_id;
  } else if (design_id && pub_id) {
    creationInfo.pub_id = pub_id;
  }

  if (folderId) {
    creationInfo.folder_id = folderId;
  }

  return creationInfo;
};
